var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParachute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.5C11.1716 17.5 10.5 18.1716 10.5 19C10.5 19.8284 11.1716 20.5 12 20.5C12.8284 20.5 13.5 19.8284 13.5 19C13.5 18.1716 12.8284 17.5 12 17.5ZM9 19C9 17.3432 10.3432 16 12 16C13.6568 16 15 17.3432 15 19C15 20.6568 13.6568 22 12 22C10.3432 22 9 20.6568 9 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12.75C1.25 6.81294 6.06294 2 12 2C17.937 2 22.75 6.81293 22.75 12.75C22.75 12.9889 22.6362 13.2135 22.4435 13.3548L15.1403 18.7105C14.8063 18.9555 14.3369 18.8832 14.092 18.5492C13.847 18.2152 13.9193 17.7458 14.2533 17.5009L20.6892 12.7812C17.94 11.0385 15.3246 10.1161 12.75 9.96632V16.75C12.75 17.1642 12.4142 17.5 12 17.5C11.5858 17.5 11.25 17.1642 11.25 16.75V9.96632C8.67536 10.1161 6.06 11.0385 3.31084 12.7812L9.74674 17.5009C10.0808 17.7458 10.153 18.2152 9.90802 18.5492C9.66307 18.8832 9.19372 18.9555 8.8597 18.7105L1.55648 13.3548C1.36382 13.2135 1.25 12.9889 1.25 12.75ZM2.8642 11.2923C3.56324 6.87627 7.38733 3.5 12 3.5C16.6126 3.5 20.4367 6.87627 21.1358 11.2923C18.0638 9.41261 15.0496 8.44449 12 8.44449C8.95042 8.44449 5.93618 9.41261 2.8642 11.2923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParachute);
export default __webpack_public_path__ + "static/media/parachute.2f82a8e0fa5cb94d025e74812d165139.svg";
export { ForwardRef as ReactComponent };